<!-- Dynamic tenant image component for any tenant-specific images -->
<template>
  <img
    :src="imagePath"
    :alt="alt || defaultAlt"
    :class="imageClass"
    @error="handleImageError"
  />
</template>

<script>
import tenantConfig from "@/config/tenant";

export default {
  name: "TenantImage",
  props: {
    // Name of the image (e.g., 'boot', 'training', 'player')
    imageName: {
      type: String,
      required: true,
    },
    // File extension (default: svg)
    extension: {
      type: String,
      default: "svg",
    },
    // Custom alt text
    alt: {
      type: String,
      default: "",
    },
    // CSS classes
    imageClass: {
      type: String,
      default: "",
    },
    // Fallback to default image if tenant-specific not found
    useFallback: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      imagePath: "",
      imageError: false,
    };
  },
  computed: {
    defaultAlt() {
      return `${this.imageName} image`;
    },
    tenantImagePath() {
      // Try tenant-specific path first
      return `/assets/tenants/${tenantConfig.id}/images/${this.imageName}.${this.extension}`;
    },
    fallbackImagePath() {
      // Fallback to generic image
      return `/img/${this.imageName}.${this.extension}`;
    },
  },
  mounted() {
    this.setImagePath();
  },
  methods: {
    setImagePath() {
      // Start with tenant-specific path
      this.imagePath = this.tenantImagePath;
    },
    handleImageError() {
      if (!this.imageError && this.useFallback) {
        this.imageError = true;
        // Fall back to generic image
        this.imagePath = this.fallbackImagePath;
      }
    },
  },
  watch: {
    imageName() {
      this.imageError = false;
      this.setImagePath();
    },
  },
};
</script>
